export const NAME = 'campaignSettings-additionalData';

export const NO_DESCRIPTION_ERROR = `${NAME}/NO_DESCRIPTION_ERROR`;
